import { BaseService } from './baseService';

class InboundNumbersService extends BaseService<
	InboundNumber,
	'inboundNumberID',
	'inboundNumbers'
> {
	constructor() {
		super('inboundNumberID', 'inboundNumber', 'inboundNumbers');
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new InboundNumbersService();
